var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wide",
    attrs: {
      "id": "warp"
    }
  }, [_c('div', {
    attrs: {
      "id": "action"
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('enter.code.from.sms')))])]), _c('div', [_c('form', {
    ref: "submitFrame",
    attrs: {
      "method": "GET",
      "target": "securePayment",
      "action": _vm.data.action
    }
  }, [_vm.data.md ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "MD"
    },
    domProps: {
      "value": _vm.data.md
    }
  }) : _vm._e(), _vm.data.paReq ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "PaReq"
    },
    domProps: {
      "value": _vm.data.paReq
    }
  }) : _vm._e(), _vm.data.termUrl ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "TermUrl"
    },
    domProps: {
      "value": _vm.data.termUrl
    }
  }) : _vm._e(), _vm.data.creq ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "creq"
    },
    domProps: {
      "value": _vm.data.creq
    }
  }) : _vm._e()]), _c('iframe', {
    ref: "frameSecure",
    attrs: {
      "id": "capusta-3ds-frame",
      "name": "securePayment"
    },
    on: {
      "load": _vm.iframeUpdate
    }
  }), _c('div', {
    staticClass: "spinner"
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }